module.exports = __webpack_public_path__ + "static/media/theme_military.58b2a75f.mp3";